import React, { useState } from 'react';
import NoteRow from './NoteRow';

/**
 * "Recently landed" — a collapsed drawer under the open notes. Landed notes are
 * the wins; they leave the primary list but stay one tap away for the wrap-up
 * recap ("what they nailed today"). Collapsed by default so the working surface
 * stays about open work.
 */
const LandedDrawer = ({
	notes,
	teacherNames = {},
	currentTeacherId = null,
	onEdit = null,
	onDelete = null,
	needsDeleteConfirm = null,
	sections = null,
	onSetSection = null,
}) => {
	const [open, setOpen] = useState(false);

	const nameFor = (note) => {
		if (!note.authorTeacherId || note.authorTeacherId === currentTeacherId) return '';
		return teacherNames[note.authorTeacherId] || '';
	};

	return (
		<div className="ld-landed">
			<button
				type="button"
				className="ld-landed__toggle"
				aria-expanded={open}
				onClick={() => setOpen((v) => !v)}>
				<i
					className={`fa-sharp fa-solid fa-chevron-${open ? 'down' : 'right'}`}
					aria-hidden="true"
				/>
				<i className="fa-sharp fa-solid fa-circle-check" aria-hidden="true" />
				<span>
					{notes.length} recently landed
				</span>
			</button>
			{open && (
				<div className="ld-landed__body">
					{notes.map((note) => (
						<NoteRow
							key={note.id}
							note={note}
							teacherName={nameFor(note)}
							onEdit={onEdit}
							onDelete={onDelete}
							deleteWarnsFamily={needsDeleteConfirm ? needsDeleteConfirm(note.id) : false}
							sections={sections}
							onSetSection={onSetSection}
						/>
					))}
				</div>
			)}
		</div>
	);
};

export default LandedDrawer;
